<template>
  <button type="submit" :class="`${className} ${{ 'w-full': block }}`">
    <span class="absolute left-0 inset-y-0 flex items-center pl-3">
      <slot name="icon" />
    </span>
    <slot />
  </button>
</template>

<script>
import { computed } from "@vue/runtime-core";
export default {
  props: {
    block: Boolean,
  },
  setup(_, context) {

    const className = computed(() => {
      return context.attrs.class
        ? `${context.attrs.class} group relative flex justify-center py-5 px-4 border border-transparent text-sm leading-3 font-medium rounded-md lg:text-lg focus:outline-none transition duration-150 ease-in-out`
        : "group relative flex justify-center py-5 px-4 border border-transparent text-sm leading-3 font-medium rounded-md text-white bg-indigo-600 lg:text-lg hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out";
    });

    return { className };
  },
};
</script>

<style></style>
